<template>
  <div class="product-hero-block" :class="{'product-hero-block--with-background': withBackground, 'product-hero-block--reverse': reverse}">
    <div class="product-hero-block__container">
      <div class="product-hero-block__row">
        <div class="product-hero-block__col product-hero-block__col--left">
          <div class="product-hero-block__header product-hero-header">
            <div class="product-hero-header__title-wrap">
              <span v-if="subtitle" class="product-hero-header__subtitle">{{ subtitle }}</span>
              <span class="product-hero-header__title">{{ title }}</span>
            </div>
          </div>
          <div class="product-hero-block__body product-hero-body">
            <ul v-if="includes.length" class="product-hero-header__list">
              <li class="product-hero-header__list-item" v-for="(item, i) in includes" :key="i">{{ item }}</li>
            </ul>
          </div>
          <div class="product-hero-block__footer product-hero-footer">
            <buy-btn
              class="product-hero-footer__btn"
              @click="handleClick"
              size="medium"
              :product-id="id"
              :without-handler="!id"
            ></buy-btn>
            <div class="product-hero-footer__price-wrap">
              <span class="product-hero-footer__price">{{ price.current | CurrencyFormatter }}</span>
              <span class="product-hero-footer__price-old">{{ price.old | CurrencyFormatter }}</span>
            </div>
          </div>
        </div>
        <component :is="id ? 'a' : 'div'" v-bind="id ? {href: `${urlLanguagePrefix}/tovar/${id}`} : {}" class="product-hero-block__col product-hero-block__col--right">
          <img :src="image" alt="product image" />
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BuyBtn from '@/components/cart/BuyBtn'
import CurrencyFormatter from '@/filters/CurrencyFormatter'

export default {
  name: 'ProductHeroBlock',
  components: { BuyBtn },
  props: {
    id: {
      type: Number,
      default: 0
    },
    image: {
      type: String,
      default: ''
    },
    characteristics: {
      type: Array,
      default: () => []
    },
    includes: {
      type: Array,
      default: () => []
    },
    subtitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    price: {
      type: Object,
      default: () => {}
    },
    withBackground: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  },
  filters: {
    CurrencyFormatter
  }
}
</script>

<style scoped lang="sass">
.product-hero-block
  position: relative

  &--with-background
    .product-hero-block__container
      background-color: #f8f8f8

  &--reverse
    .product-hero-block__row
      +mmin($tablet)
        flex-flow: row-reverse nowrap

.product-hero-block__container
  position: relative
  overflow: hidden
  background-color: #fff
  margin: 0 -15px

  +mmin($tablet)
    margin: 0

  &:before
    content: ''
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background-image: url('/img/black-friday/shum.png')
    background-size: 120px 120px
    background-repeat: repeat
    pointer-events: none
    mix-blend-mode: screen

.product-hero-block__row
  display: flex
  flex-flow: column-reverse

  +mmin($tablet)
    flex-flow: row nowrap

.product-hero-block__col--left
  flex: 0 0 100%
  z-index: 1
  width: 100%
  margin: auto
  padding: 0 15px

  +mmin($tablet)
    flex: 0 0 50%
    padding: 0 50px

.product-hero-block__col--right
  position: relative
  flex: 0 0 100%

  +mmin($tablet)
    flex: 0 0 50%

  img
    display: block
    width: 100%

.product-hero-header
  margin-bottom: 10px
  display: flex
  flex-flow: column

  +mmin($tablet)
    margin-bottom: 20px
    flex-flow: row nowrap

.product-hero-header__subtitle
  display: block
  font-size: 16px
  font-weight: 500
  text-transform: uppercase

  +mmin($tablet)
    font-size: 24px
    margin-bottom: 5px

.product-hero-header__title
  font-size: 48px
  text-transform: uppercase
  white-space: nowrap
  margin-left: -2px
  font-weight: 700

  +mmin($tablet)
    font-size: 64px

    margin-left: -5px

.product-hero-header__list
  +list-unstyled
  display: flex
  flex-flow: column
  flex-shrink: 0
  column-count: 2

.product-hero-header__list-item
  font-size: 18px
  margin-right: 3px
  color: rgba(51, 51, 51, 0.7)

  &:not(:first-child)
    &:before
      content: '+ '
      color: $main-color

.product-hero-body
  margin-bottom: 5px

  +mmin($tablet)
    margin-bottom: 45px

.product-hero-body__list
  +list-unstyled
  display: flex
  align-items: stretch
  flex-flow: row wrap

.product-hero-body__list-item
  display: flex
  flex-flow: column
  width: 50%
  min-width: 130px
  margin-bottom: 25px

  +mmin($tablet)
    width: 25%
    max-width: 150px
    min-width: 150px
    margin-right: 50px

.product-hero-body__list-title
  text-transform: uppercase
  color: rgba(255, 255, 255, 0.5)
  margin-bottom: 10px
  font-size: 14px

  &--single
    color: #fff
    margin-bottom: 0

.product-hero-body__list-number
  margin-top: auto
  font-size: 24px
  color: #fff
  display: flex
  align-items: baseline
  flex-shrink: 0

  +mmin($tablet)
    font-size: 30px

  span
    font-size: 18px
    margin-left: 5px
    margin-right: 5px

.product-hero-footer
  display: flex
  align-items: flex-start
  padding-top: 30px

  +mmin($tablet)
    align-items: center
    padding-top: 0

.product-hero-footer__price-wrap
  display: flex
  flex-flow: column
  flex-shrink: 0
  margin-left: 20px

  +mmin($tablet)
    flex-flow: row wrap
    flex-shrink: initial
    align-items: center
    margin-left: 50px

.product-hero-footer__price
  display: flex
  align-items: flex-start
  color: $main-color
  letter-spacing: -0.03em
  font-size: 30px
  font-weight: 500
  line-height: 1
  flex-shrink: 0

  +mmin(425)
    font-size: 36px

  +mmin($tablet)
    margin-right: 20px

  span
    font-size: 20px
    margin-left: 5px

    +mmin(425)
      font-size: 24px

.product-hero-footer__price-old
  display: flex
  align-items: flex-start
  position: relative
  font-size: 18px
  font-weight: 500
  width: max-content
  line-height: 1
  margin-top: 5px
  flex-shrink: 0

  +mmin($tablet)
    font-size: 30px
    margin-top: 0

  span
    font-size: 12px
    margin-left: 5px

    +mmin($tablet)
      font-size: 18px

  &:before
    content: ''
    position: absolute
    width: 105%
    height: 2px
    background-color: $main-color
    top: 50%
    left: 50%
    transform: translate(-50%, 100%)
</style>
